import React from 'react';
import PropTypes from 'prop-types';
import { PhoneCodeLabel } from './PhoneCodeLabel';

const CountryCodeLabelRenderer = React.memo((props) => {
  // The value is passed in the props object, not directly as a prop
  return <PhoneCodeLabel countryCode={props.value} />;
});

CountryCodeLabelRenderer.displayName = 'CountryCodeLabelRenderer';

CountryCodeLabelRenderer.propTypes = {
  value: PropTypes.string.isRequired
};

// Export the render function directly for better performance
export const renderCountryCodeLabel = (props) => (
  <CountryCodeLabelRenderer {...props} />
);

export default CountryCodeLabelRenderer;
